import { SyncFn } from './sync-coordinator';
import { getAlignmentSyncPosition } from './source-positions';
import { applyToFreeView } from './apply-to-free-view';

/**
 * Syncs from an alignment source pane to a FreeView target pane.
 * Updates the look direction towards the alignment point and propagates
 * source quaternion + fov to the target frustum.
 *
 * Alignment source orientation is always meaningful.
 */
export const syncAlignmentToFreeView: SyncFn = async (source, target) => {
  const syncPosition = getAlignmentSyncPosition(source);
  if (!syncPosition) return;

  const sourceViewer = source.viewerWrapper()?.viewer;
  const targetViewer = target.viewerWrapper()?.viewer;
  if (!sourceViewer || !targetViewer) return;

  applyToFreeView(target, targetViewer, sourceViewer, syncPosition, true);
};
